import ApiService from '../api.service';

const BASE_URL = 'customers';

export const CustomerService = {
  /**
   * Get all customers with pagination
   * @param {Object} params - Query parameters
   * @returns {Promise} - API response
   */
  getAll(params) {
    return ApiService.query(BASE_URL, { params });
  },

  /**
   * Get customer by ID
   * @param {string} id - Customer ID
   * @returns {Promise} - API response
   */
  getById(id) {
    return ApiService.get(`${BASE_URL}/${id}`);
  },

  /**
   * @param {Object} data - Customer data
   * @returns {Promise} - API response
   */
  create(data) {
    return ApiService.post(BASE_URL, data);
  },

  /**
   * @param {string} id - Customer ID
   * @param {Object} data - Updated customer data
   * @returns {Promise} - API response
   */
  update(id, data) {
    return ApiService.put(`${BASE_URL}/${id}`, data);
  },

  /**
   * @param {string} id - Customer ID
   * @returns {Promise} - API response
   */
  delete(id) {
    return ApiService.delete(`${BASE_URL}/${id}`);
  },

  /**
   * Search customers by keyword
   * @param {Object} params
   * @param {string} params.keyword - Search keyword
   * @returns {Promise} - API response
   */
  smartSearch(params) {
    return ApiService.query(`${BASE_URL}/smart-search`, { params });
  },

  /**
   * Tra khách hàng theo số điện thoại (prefix match) — BE: detailByPhoneNumberLike.
   * Dùng cho ô lọc phone (chọn lại KH cũ) ở các màn nhập KH.
   * @param {string} phoneNumber - Số điện thoại (prefix)
   * @returns {Promise} - API response (data.data = mảng KH khớp)
   */
  getByPhone(phoneNumber) {
    return ApiService.query(`${BASE_URL}/get-by-phone`, {
      params: { phoneNumber },
    });
  },

  /**
   * Tra khách hàng doanh nghiệp (LIKE name/email/phoneNo/taxNo) — BE: GET /businesses.
   * Dùng cho ô lọc MST (chọn lại DN cũ) ở các màn nhập KH.
   * @param {string} search - Từ khoá (MST / tên / SĐT)
   * @returns {Promise} - API response (data.data.data = mảng DN khớp)
   */
  searchBusiness(search) {
    return ApiService.query('businesses', {
      params: { search, page: 1, limit: 10 },
    });
  },

  /**
   * Get business customers
   * @param {Object} params - Query parameters
   * @returns {Promise} - API response
   */
  getBusinessCustomers(params) {
    return ApiService.query(`${BASE_URL}/business`, { params });
  },

  /**
   * Get customer by business ID
   * @param {string} id - Business customer ID
   * @returns {Promise} - API response
   */
  getBusinessCustomerById(id) {
    return ApiService.get(`${BASE_URL}/business/${id}`);
  },

  /**
   * Create a new business customer
   * @param {Object} data - Business customer data
   * @returns {Promise} - API response
   */
  createBusinessCustomer(data) {
    return ApiService.post(`${BASE_URL}/business`, data);
  },

  /**
   * Update an existing business customer
   * @param {string} id - Business customer ID
   * @param {Object} data - Updated business customer data
   * @returns {Promise} - API response
   */
  updateBusinessCustomer(id, data) {
    return ApiService.put(`${BASE_URL}/business/${id}`, data);
  },

  /**
   * Delete a business customer
   * @param {string} id - Business customer ID
   * @returns {Promise} - API response
   */
  deleteBusinessCustomer(id) {
    return ApiService.delete(`${BASE_URL}/business/${id}`);
  },
};
